import { render, staticRenderFns } from "./noDespachadoTable.vue?vue&type=template&id=d65df434&"
import script from "./noDespachadoTable.vue?vue&type=script&lang=js&"
export * from "./noDespachadoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports